module.exports = __webpack_public_path__ + "static/carafe-large-65d5a6962ab0b2a999d54302e60ed1b0.jpg";